import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routes } from '../../routes';
import { Wizard } from '@vwfs-bronson/bronson-react';

const AppWizard: any = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  let step = 0;

  if (!pathname.includes(routes.error)) {
    step = 1;
  }

  if (!window.location.pathname || window.location.pathname === routes.application.legitimationLanding) {
    step = 1;
  } else if (window.location.pathname.includes(routes.application.upload)) {
    step = 2;
  } else if (window.location.pathname.endsWith(routes.application.legitimationLanding)) {
    step = 1;
  } else if (window.location.pathname.includes(routes.error) || window.location.pathname.includes(routes.linkExpired)) {
    step = 0;
  }

  const isUpload = step === 2;
  const isConfirmation = window.location.pathname.includes(routes.application.legitimationResult);

  if (step > 0) {
    const stepStringsArray = [t('common:wizard.legitimation'), t('common:wizard.upload')];

    const currentStepString = stepStringsArray[step - 1];
    return (
      <Wizard
        collapseBreakpoint="s"
        collapsedText={currentStepString}
        collapsedCounter={`${step}/${stepStringsArray.length}`}
      >
        <Wizard.Item active={step === 1} done={isConfirmation || isUpload}>
          {t('common:wizard.legitimation')}
        </Wizard.Item>
        <Wizard.Item active={step === 2} done={isConfirmation}>
          {t('common:wizard.upload')}
        </Wizard.Item>
      </Wizard>
    );
  }
};

export default AppWizard;
